export default __webpack_public_path__ + "static/media/evil-laugh.c9c4d0fd.mp3";